(function($){

    $(window).on('load', function(){
        var $cookiePopupWindow = $('.cookie-popup');
        if ($cookiePopupWindow.length) {
            var cookiePopupStatus = getCookie('_cookie_popup');
            if (cookiePopupStatus !== 'hide') {
                $cookiePopupWindow.show(300);
            }
        }
    });

    $(document).ready(function($){
        var $cookiePopupWindow = $('.cookie-popup');
        if ($cookiePopupWindow.length) {
            var $cookiePopupClose = $('.cookie-popup__close');
            $cookiePopupClose.on('click tap', function () {
                setCookie('_cookie_popup', 'hide', 60, '/');
                $cookiePopupWindow.hide(300);
                return false;
            });
        }
    });

}(jQuery));
